import React from 'react';
import { IInternalTransferData } from '../../../../../types/order/escrow/IInternalTransferData';
import { Heading, Table } from '@zillow/constellation';
import { InternalTransferRow } from './InternalTransferRow';
import { useGetPaymentsData } from '../../hooks/useGetPaymentsData';

interface IInternalTransferContainerProps {
  internalTransfers: IInternalTransferData[];
}

const tableHeaders = [
  'Fee Information',
  'Category',
  'Memo',
  'Amount',
  'Source Account',
  'Destination Account',
  'Wells Fargo Transaction Number',
  'Bank Reference',
  'Sent At',
  'Disbursed At',
  'Completed At',
  'Voided At',
];

export const InternalTransfersContainer: React.FC<IInternalTransferContainerProps> = ({ internalTransfers }) => {
  const data = useGetPaymentsData(internalTransfers);

  return (
    <>
      <Heading level={1}>Internal Transfers</Heading>
      <Table aria-label="Internal Transfer Disbursements" size={'sm'} appearance={'zebra'}>
        <Table.Header appearance="dark">
          <Table.Row>
            {tableHeaders.map((header) => (
              <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map((item) => (
            <InternalTransferRow key={item.id} item={item} />
          ))}
        </Table.Body>
      </Table>
    </>
  );
};
